// 导入模块
import Vue from 'vue'
import axios from 'axios'
import iView, {Message} from 'iview'
import store from '@/store'
import router from '@/router'
import Cookies from 'js-cookie'
Vue.use(iView)

const port_code = {
  success : 0,
  unlogin : -2,
  firstLogin : 1514,
};

export default function fetch(options,headers) {
  return new Promise((resolve, reject) => {
    var uid = Cookies.get("uid");
    var token = Cookies.get("utn");
    var userInfo = Cookies.get("userInfo");
    var lang = Vue.config.lang;
    if ( !headers ) {
      headers = {
        "u_id": uid,
        "token_id": token
      }
      if (userInfo){
        headers.u_type = JSON.parse(userInfo).userType
      }
    }
    const instance = axios.create({
      timeout: 1200000000,
      headers: headers,
      params : {
        lang : lang === 'en-US' ? 'en_US' : 'zh_CN',
        time:new Date().getTime()
      }
    })
    // http request 拦截器
    instance.interceptors.request.use(
      config => {
        iView.LoadingBar.start();
        return config
      },
      err => {
        Message.error({
          content: 'request error',
          duration: 3,
          closable: true
        });
        iView.LoadingBar.error()
        return Promise.reject(err)
      })

    // http response 拦截器
    instance.interceptors.response.use(
      response => {
        iView.LoadingBar.finish()
        return response
      },
      error => {
        iView.LoadingBar.error();
        if ( error && !error.response ) {
          error.message = 'request timeout'
        }
        switch (error && error.response && error.response.status) {
          case 400:
            error.message = 'request error'
            break

          case 404:
            error.message = 'request url error'
            break

          case 500:
            error.message = 'Internel error'
            break

          case 502:
            error.message = 'gateway error'
            break

          case 503:
            error.message = 'service unavailable'
            break

          case 504:
            error.message = 'gateway timeout'
            break

          default:
            error.message = "request timeout";
        }
        return Promise.reject(error) // 返回接口返回的错误信息
      })

    // 请求处理
    instance(options)
      .then((res) => {
        // 请求成功时,根据业务判断状态
        if (res.data.code === port_code.success) {
          resolve(res.data.data);
          return false
        } else if (res.data.code === port_code.unlogin) {
          store.commit("CLEAR_USERID_TOKEN");
          router.replace({name: "login"})
        }else if(res.data.code === port_code.firstLogin){
          router.replace({name: "firstLogin"})
        }else if(res.data.code === 1005){
          Message.info({
            content: res.data.msg,
            duration: 10,
            closable: true
          });
        } else {
          Message.error({
            content: res.data.msg,
            duration: 3,
            closable: true
          });
          reject(res.data.msg);
        }
        return false
      })
      .catch((error) => {
        // 请求失败时,根据业务判断状态
        Message.error({
          content: error.message,
          duration: 3,
          closable: true
        });
        reject(error);
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/fetch.js